import { exists } from '@/api'

export interface Donor {
  id: number
  code: string
  name: string
  shortName: string
  rate: number
  phoneType: string
  phone: string
  zipCode: string
  memo: string
  revision: number
}

export const defaultDonor = (): Donor => ({
  id: 0,
  code: '',
  name: '',
  shortName: '',
  rate: 0,
  phoneType: '',
  phone: '',
  zipCode: '',
  memo: '',
  revision: 0
})

export function DonorFromJSON(json: any): Donor {
  return DonorFromJSONTyped(json)
}

export function DonorFromJSONTyped(json: any): Donor {
  if (json === null || json === undefined) return json
  return {
    id: exists(json, 'id') ? json.id : 0,
    code: exists(json, 'code') ? json.code : '',
    name: exists(json, 'name') ? json.name : '',
    shortName: exists(json, 'short_name') ? json.short_name : '',
    rate: exists(json, 'rate') ? json.rate : 1,
    phoneType: exists(json, 'phone_type') ? json.phone_type : '',
    phone: exists(json, 'phone') ? json.phone : '',
    zipCode: exists(json, 'zip_code') ? json.zip_code : '',
    memo: exists(json, 'memo') ? json.memo : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
